module.exports = __webpack_public_path__ + "img/ni.4bd4f1a1.svg";